// extracted by mini-css-extract-plugin
export var about = "planer-och-kontakt-module--about--ql2B7";
export var content = "planer-och-kontakt-module--content--2mJMr";
export var image = "planer-och-kontakt-module--image--2UHmv";